// -----------------------------------------------------------------------------
// SIDE NAV CONFIG
// -----------------------------------------------------------------------------
export const SIDE_NAV_ENABLED = false
export const SIDE_NAV_OPTIONS = [
  {
    // anyPerm: ['dashboard:*'],
    children: [],
    props: {
      prependIcon: 'mdi-view-dashboard',
      to: { path: '/' },
    },
    requiresAuth: true,
    title: 'Dashboard',
    value: 'dashboard',
  },
  // {
  //   props: {
  //     prependIcon: 'mdi-home-account',
  //     to: { path: '/admin' },
  //   },
  //   // anyPerm: ['admin:*'],
  //   requiresAuth: true,
  //   title: 'Admin',
  //   value: 'admin',
  // },
  {
    // anyPerm: ['dashboard:*'],
    children: [],
    props: {
      prependIcon: 'mdi-chart-bar',
      to: { path: '/broker' },
    },
    requiresAuth: true,
    title: 'Broker',
    value: 'broker',
  },
  {
    // anyPerm: ['camera:*'],
    children: [],
    props: {
      prependIcon: 'mdi-devices',
      to: { path: '/devices' },
    },
    requiresAuth: true,
    title: 'Devices',
    value: 'devices',
  },
  {
    children: [],
    props: {
      prependIcon: 'mdi-label-multiple',
      to: { path: '/tags' },
    },
    requiresAuth: true,
    title: 'Tags',
    value: 'tags',
  },
  // {
  //   // anyPerm: ['developer:*'],
  //   children: [],
  //   developerOnly: true,
  //   props: {
  //     prependIcon: 'mdi-language-python',
  //     // prependIcon: 'mdi-developer-board',
  //     to: { path: '/developer' },
  //   },
  //   requiresAuth: true,
  //   title: 'Developer Only',
  //   value: 'developer',
  // },
]

// -----------------------------------------------------------------------------
// BOTTOM NAV CONFIG
// -----------------------------------------------------------------------------
export const BOTTOM_NAV_ENABLED = true
export const BOTTOM_NAV_OPTIONS = [
  {
    // anyPerm: ['dashboard:*'],
    children: [],
    props: {
      prependIcon: 'mdi-view-dashboard',
      to: { path: '/' },
    },
    requiresAuth: true,
    title: 'Dashboard',
    value: 'dashboard',
  },
  // {
  //   props: {
  //     prependIcon: 'mdi-home-account',
  //     to: { path: '/admin' },
  //   },
  //   // anyPerm: ['admin:*'],
  //   requiresAuth: true,
  //   title: 'Admin',
  //   value: 'admin',
  // },
  {
    // anyPerm: ['dashboard:*'],
    children: [],
    props: {
      prependIcon: 'mdi-chart-bar',
      to: { path: '/broker' },
    },
    requiresAuth: true,
    title: 'Broker',
    value: 'broker',
  },
  {
    // anyPerm: ['camera:*'],
    children: [],
    props: {
      prependIcon: 'mdi-devices',
      to: { path: '/devices' },
    },
    requiresAuth: true,
    title: 'Devices',
    value: 'devices',
  },
  {
    children: [],
    props: {
      prependIcon: 'mdi-label-multiple',
      to: { path: '/tags' },
    },
    requiresAuth: true,
    title: 'Tags',
    value: 'tags',
  },
  // {
  //   // anyPerm: ['developer:*'],
  //   children: [],
  //   developerOnly: true,
  //   props: {
  //     prependIcon: 'mdi-language-python',
  //     // prependIcon: 'mdi-developer-board',
  //     to: { path: '/developer' },
  //   },
  //   requiresAuth: true,
  //   title: 'Developer Only',
  //   value: 'developer',
  // },
]
